import {Box, Divider, Grid, Stack, Typography} from "@mui/material";
import Page from "../Components/Page";
import {useNavigate} from "react-router-dom";
import Card from "../Components/Card";
import ArticleCard from "../Components/ArticleCard";
import Chemistry from "../Images/Chemistry.png";
import Biology from "../Images/Biology.png";
import Maths from "../Images/Maths.png";
import Physics from "../Images/Physics.png";
import {useArticles} from "../Util/useArticles";

function CardListItemTextIcon({text, icon, nav}:{text: string, icon?: string, nav?: string}) {
    const navigate = useNavigate();
    return (
        <Card onClick={nav ? () => navigate(nav) : undefined} contentSx={{padding: "8px !important", paddingLeft: "16px !important", paddingRight: "16px !important"}}>
            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                <Typography color={"physics"} variant="h5">{text}</Typography>
                <Box component={"img"} src={icon} width={"60px"}/>
            </Stack>
        </Card>
    );
}

function SocialsCard() {
    return (
        <Card>
            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                Socials
            </Stack>
        </Card>
    );
}

export default function HomePage() {
    const news = useArticles("news");

    if (!news || news.length === 0) return;
    const [featured, ...rest] = news;

    return (
        <Page>
            <Grid container>
                <ArticleCard grid xs={12} md={6} article={featured} variant={"featured"}/>
                <Grid item xs={12} md={3}>
                    <Stack>
                        <Typography variant="h5">Trending News</Typography>

                    </Stack>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Stack>
                        <Typography variant="h5">Learn</Typography>
                        <CardListItemTextIcon text="Physics" nav={"/learn/physics"} icon={Physics}/>
                        <CardListItemTextIcon text="Chemistry" nav={"/learn/chemistry"} icon={Chemistry}/>
                        <CardListItemTextIcon text="Biology" nav={"/learn/biology"} icon={Biology}/>
                        <CardListItemTextIcon text="Maths" nav={"/learn/maths"} icon={Maths}/>
                        <SocialsCard/>
                    </Stack>
                </Grid>
                <Grid item xs={12}><Divider sx={{m: 3}}/><Typography variant="h4" textAlign={"center"}>Learn on Scimos</Typography></Grid>
                {rest.map((a) => <ArticleCard key={a.id} grid xs={12} sm={6} article={a} variant={"row"}/>)}
            </Grid>
        </Page>
    );
}
